import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";

import * as serviceWorker from "./serviceWorker";
import App from "./App";
import { createOurStore } from "./store/store";
import "./index.css";
import Firebase, { FirebaseContext } from "./data/Firebase";
import { Routing } from "./data/routing/routing";

const firebaseInstance = new Firebase();
const routingInstance = new Routing();

ReactDOM.render(
  <React.StrictMode>
    <FirebaseContext.Provider value={firebaseInstance}>
      <Provider
        store={createOurStore({
          firebase: firebaseInstance,
          routing: routingInstance,
        })}
      >
        <App routing={routingInstance} />
      </Provider>
    </FirebaseContext.Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
